import { types } from 'mobx-state-tree';
const Details = {
    companyName: types.maybeNull(types.string),
    timeSinceJobChange: types.number,
    timePeriod: types.string,
};
const DetailsModel = types.model(Details);
const model = {
    changedJob: types.optional(types.boolean, false),
    details: types.optional(types.maybeNull(DetailsModel), null),
};
const PreviousJobDataModel = types.model(model);
export default PreviousJobDataModel;
